
import { Vue, Component, Prop } from 'vue-property-decorator';
import { StoreForImport } from '@/features/shipment/types';

@Component
export default class ECommerceTableRow extends Vue {
  @Prop({ required: true }) store!: StoreForImport
}
